<template>
	<div>

    <el-dialog title="Aprobar horas extra" :visible.sync="approveVisible">
        <el-form :model="approveForm" @submit.prevent="handleApprove">
            <table class="form">
                <tr><th>Empleado:</th><td>{{approveForm.employee_name}}</td></tr>
                <tr><th>Fecha:</th><td>{{approveForm.date}}</td></tr>
                <tr><th>Turno:</th><td>{{approveForm.computed.shift}}</td></tr>
                <tr><th>Entrada:</th><td>{{approveForm.computed.in}} hs.</td></tr>
                <tr><th>Salida:</th><td>{{approveForm.computed.out}} hs.</td></tr>
                <tr><th>Total:</th><td>{{formatTime(approveForm.computed.total)}}</td></tr>
                <tr><th>Horas extra aprobadas:</th><td>{{formatTime(approveForm.computed.overtime)}}</td></tr>
                <tr><th>Máximo aprobable (trabajado):</th><td><strong>{{formatTime(approveForm.maxOvertimeMinutes / 60)}}</strong></td></tr>
            </table>
            <el-form-item v-if="this.$auth.can(['overtime.comment'])" label="Comentario">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Comentario"
                    v-model="approveForm.comment">
                </el-input>
            </el-form-item>
            <div v-else>
                <h5>Comentario:</h5>
                {{approveForm.comment}}
            </div>
            <el-form-item v-if="this.$auth.can(['overtime.approve'])" label="Total horas extra a aprobar">
                <div>
                    <el-input-number v-model="approveForm.overtimeToAuthorizeHours" :min="0" :max="maxApproveHours" size="small" style="width: 100px;"></el-input-number> h &nbsp;
                    <el-input-number v-model="approveForm.overtimeToAuthorizeMins" :min="0" :max="maxApproveMins" size="small" style="width: 100px;"></el-input-number> m
                </div>
                <div v-if="approveExceedsLimit" style="color: #f56c6c; font-size: 12px; line-height: 1.4em; margin-top: 4px;">
                    No puede aprobar más de {{formatTime(approveForm.maxOvertimeMinutes / 60)}} (horas extra trabajadas).
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <template v-if="this.$auth.can(['overtime.approve','overtime.comment'])">
                <el-button @click="approveVisible = false">Cancelar</el-button>
                <el-button type="primary" @click="handleApprove" :disabled="approveExceedsLimit && $auth.can(['overtime.approve'])">Confirmar</el-button>
            </template>
            <template v-else>
                <el-button type="primary" @click="approveVisible = false">Cerrar</el-button>
            </template>
        </span>
    </el-dialog>

    <el-dialog title="Aprobar horas extra" :visible.sync="massApproveVisible" width="70%">
        <el-form :model="massApproveForm" @submit.prevent="handleMassApprove">
            <el-form-item v-if="this.$auth.can(['overtime.approve'])" label="Empleados">
                <el-transfer
                    filterable
                    :filter-method="employeesFilter"
                    filter-placeholder="Empleados"
                    v-model="massApproveForm.selectedEmployees"
                    :data="massApproveForm.employees"
                    :titles="['Disponibles', 'Seleccionados']">
                </el-transfer>
            </el-form-item>
            <el-form-item v-if="this.$auth.can(['overtime.approve'])" label="Días">
                <el-checkbox v-for="(day, index) in week_days" 
                    v-model="massApproveForm.selectedDays[day.date]" 
                    :key="'c_' + index + '_' + day.date" 
                    :label="day.label" 
                    border
                    size="mini"></el-checkbox>
            </el-form-item>
            <el-form-item v-if="this.$auth.can(['overtime.comment'])" label="Comentario">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Comentario"
                    v-model="massApproveForm.comment">
                </el-input>
            </el-form-item>
            <div v-else>
                <h5>Comentario:</h5>
                {{massApproveForm.comment}}
            </div>
            <el-form-item v-if="this.$auth.can(['overtime.approve'])" label="Total horas extra a aprobar">
                <div>
                    <el-input-number v-model="massApproveForm.overtimeToAuthorizeHours" :min="0" :max="24" size="small" style="width: 100px;"></el-input-number> h &nbsp;
                    <el-input-number v-model="massApproveForm.overtimeToAuthorizeMins" :min="0" :max="59" size="small" style="width: 100px;"></el-input-number> m
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <template v-if="this.$auth.can(['overtime.approve','overtime.comment'])">
                <el-button @click="approveVisible = false">Cancelar</el-button>
                <el-button type="primary" @click="handleMassApprove">Confirmar</el-button>
            </template>
            <template v-else>
                <el-button type="primary" @click="massApproveVisible = false">Cerrar</el-button>
            </template>
        </span>
    </el-dialog>


	<div style="margin: 2px;">
        <!-- <a :disabled="false" class="btn btn-default btn-sm" @click="handleFillMassForm()"><i class="fa fa-users"></i> Aprobación masiva</a> -->
        <strong>Referencias:</strong> <el-button type="primary" size="mini">Aprob./No aprob.</el-button> No se aprobaron horas extra &nbsp;&nbsp;-<el-button type="success" size="mini">Aprob./No aprob.</el-button> Se aprobaron todas las horas &nbsp;&nbsp;-<el-button type="warning" size="mini">Aprob./No aprob.</el-button> Se aprobaron solo algunas horas
    </div>

    <el-data-table 
        :resourceUrl="'/reports/attendancedetailsbyemployee'"
        :filters="filters"
        :config="config"
        @filtersSubmited="handlefiltersSubmited"
        @itemsFetched="getStatus"
        ref="dataTable">

        <template slot="filtersDescription">
            Área: <strong>{{functional_area_name}}</strong> - Semana: <strong>{{filters.date_from}}</strong> a <strong>{{filters.date_to}}</strong> - Habilitando a partir de {{filters.threshold * 60}} minutos extra
            <template v-if="statusFetched">
                <el-alert
                    title="Período cerrado"
                    type="warning"
                    show-icon
                    :closable="false"
                    v-if="statusClosed">
                    <div class="box-tools pull-right" v-if="this.$auth.can(['overtime.open_period'])">
                        <el-button type="primary" icon="el-icon-edit" @click="handleOpenPeriod">Reabrir</el-button>
                    </div>
                    <div v-if="1">
                        El período seleccionado ya fue liquidado y no se permiten modificaciones
                    </div>
                </el-alert>
                <el-alert
                    title="Período activo"
                    type="info"
                    show-icon
                    :closable="false"
                    v-if="!statusClosed && this.$auth.can(['overtime.close_period'])">
                    <div class="box-tools pull-right">
                        <el-button type="danger" icon="el-icon-close" @click="handleClosePeriod">Cerrar</el-button>
                    </div>
                        <div v-if="!statusPartiallyClosed">
                            El período seleccionado aún permite modificaciones
                        </div>
                        <div v-else>
                            Los siguientes períodos se encuentran cerrados y no permiten modificaciones: <strong>{{closedPeriods}}</strong>
                        </div>
                </el-alert>
            </template>
        </template>

        <template slot="filtersForm">
        <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="Área" prop="functional_area_id" required :rules="[{required: true, message: 'Campo requerido'}]" label-width="75px">
                <el-select v-model="filters.functional_area_id" filterable placeholder="Filtre / Seleccione" style="width: 200px;">
                    <el-option
                        v-for="item in functional_areas_for_user"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="Semana" prop="date_from" required :rules="[{required: true, message: 'Campo requerido'}]" label-width="75px">
                <el-week-picker
                    style="width: 200px;"
                    :value="filters.date_from"
                    @input="weekPickerChange" 
                    type="week"
                    format="yyyy-MM-dd"
                    align="right"
                    placeholder="Seleccione una semana">
                </el-week-picker>
            </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="Habilitar a partir de " prop="threshold">
                <el-select v-model="filters.threshold" class="short-select">
                    <el-option
                        v-for="item in thresholdOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                &nbsp;minutos extra
            </el-form-item>
            </el-col>
        </el-row>
        </template>

        <template slot="columns">
            <el-table-column
                prop="employee_name"
                label="Empleado"
                width="120">
            </el-table-column>
            <el-table-column v-for="(day, index) in week_days"
                :label="day.label + lineBreak + day.date"
                class-name="cell"
                label-class-name="date-cell-label"
                :key="'day_col_' + index + '_' + day.date"
                :column-key="day.date">
                <template slot-scope="scope">
                    <div v-if="day.date in scope.row.records && Object.keys(scope.row.records[day.date].computed).length > 0">
                        <strong>To:</strong> {{scope.row.records[day.date].computed.shift}} <br>
                        <strong>Ent:</strong> {{(scope.row.records[day.date].computed.in) ? scope.row.records[day.date].computed.in.substr(0, scope.row.records[day.date].computed.in.length - 3) : ''}}hs. <br>
                        <strong>Sal:</strong> {{(scope.row.records[day.date].computed.out) ? scope.row.records[day.date].computed.out.substr(0, scope.row.records[day.date].computed.out.length - 3) : ''}}hs. <br>
                        <strong>Tot:</strong> {{formatTime(scope.row.records[day.date].computed.total)}} <br>
                        <template v-if="scope.row.records[day.date].authorized_by != null">
                            <strong>Aut:</strong> {{scope.row.records[day.date].authorized_by}} <br> {{'(' + formatDateTime(scope.row.records[day.date].authorized_on) + ')'}} <br>
                        </template>
                        <template v-if="scope.row.records[day.date].comment != null">
                            <strong>Com:</strong> {{(scope.row.records[day.date].comment.length > 20) ? scope.row.records[day.date].comment.substring(1, 18) + '...' : scope.row.records[day.date].comment}} <br>
                        </template>
                        <template v-if="!needAuthorization(scope.row, day.date)">
                        <strong>Ext: </strong> {{formatTime(scope.row.records[day.date].computed.overtime || 0)}} 
                        </template>
                        <!-- <template v-if="needAuthorization(scope.row, day.date)"> -->
                        <template v-else>
                            <el-button 
                                :type="scope.row.records[day.date].total_overtime <= filters.threshold ? 'info' : (scope.row.records[day.date].authorized_by == null) ? 'primary' : (scope.row.records[day.date].unauthorized_overtime == 0) ? 'success' : 'warning'" 
                                @click="handleFillForm(scope.row, day.date)" 
                                size="mini" 
                                :disabled="scope.row.records[day.date].total_overtime <= filters.threshold || day.statusClosed">
                                {{(scope.row.records[day.date].computed.overtime != null) ? formatTime(scope.row.records[day.date].computed.overtime) : 0}} / {{formatTime(scope.row.records[day.date].unauthorized_overtime)}}
                            </el-button>
                        </template>
                    </div>
                </template>
            </el-table-column>
        </template>
    </el-data-table>

	</div>
</template>

<style>
.el-table .cell {
    padding-left: 3px;
    padding-right: 3px;
    white-space: pre-line;
    word-break: break-word;
    vertical-align: top;
    padding: 2px 0 2px 15px;
}
.el-table__body .cell {
    font-size: 11px;
    line-height: 1.3em;
}
table.form th {
    text-align: right;
}
table.form th,
table.form td {
    padding: 3px 5px;
}
th.date-cell-label div.cell {
    white-space: pre;
}
.el-alert__content {
    width: 100%;
}
.el-transfer-panel {
    width: 320px;
}
.el-checkbox.is-bordered {
    margin-left: 5px;
    margin-right: 5px;
}
.short-select.el-select {
    width:70px;
}
</style>
<script>
    import { mapGetters, mapActions } from "vuex";
    import el_data_table from './el-data-table.vue';
    import el_week_picker from './el-week-picker.vue';
    export default {
    	data() {
    		return {
                thresholdOptions: [
                    {label: "1", value: 1/60},
                    {label: "15", value: .25},
                    {label: "30", value: .5},
                    {label: "45", value: .75},
                    {label: "60", value: 1},
                    {label: "90", value: 1.5},
                    {label: "120", value: 2},
                ],
                formLoading: false,
                status: [],
                statusFetched: false,
                statusClosed: false,
                statusPartiallyClosed: false,
                closedPeriods: null,
                lineBreak: "\n",
                showFilters: true,
    			employees: [],
    			filters: {
    				functional_area_id: null,
                    date_from: null,
                    date_to: null,
                    threshold: 1/60,
                },
                config: {
                    selectFiltersAreAtomic: true,
                },
    			shifts: [],
                devices: [],
    			// functional_areas: [],
    			approveForm: {
                    employee_id: null,
                    employee_name: null,
                    date: null,
                    overtimeToAuthorizeHours: null,
                    overtimeToAuthorizeMins: null,
                    maxOvertimeMinutes: 0,
                    computed: {},
                    comment: null
    			},
    			massApproveForm: {
                    employees: [],
                    selectedEmployees: [],
                    selectedDays: {},
                    overtimeToAuthorizeHours: null,
                    overtimeToAuthorizeMins: null,
                    comment: null
    			},
                approveVisible: false,
                massApproveVisible: false,
                week_days: [],
                hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
                mins: [0, 5, 10, 15, 20, 30, 40, 45, 50],
    		}
    	},
        computed: {
            ...mapGetters(["functional_areas_for_user"]),
            'functional_area_name': function () {
                let item = _.find(this.functional_areas_for_user, (item) => {return item.value == this.filters.functional_area_id});
                if (item != undefined) {
                    return item.label;
                } else {
                    return '-';
                }
            },
            maxApproveHours() {
                return Math.floor((this.approveForm.maxOvertimeMinutes || 0) / 60);
            },
            maxApproveMins() {
                // Si ya está en el máximo de horas, los minutos se limitan al remanente
                if ((this.approveForm.overtimeToAuthorizeHours || 0) >= this.maxApproveHours) {
                    return (this.approveForm.maxOvertimeMinutes || 0) % 60;
                }
                return 59;
            },
            approveTotalMinutes() {
                return (this.approveForm.overtimeToAuthorizeHours || 0) * 60 + (this.approveForm.overtimeToAuthorizeMins || 0);
            },
            approveExceedsLimit() {
                return this.approveTotalMinutes > (this.approveForm.maxOvertimeMinutes || 0);
            }
        },
        components: {
            'el-data-table': el_data_table,
            'el-week-picker': el_week_picker,
        },
        mounted() {
            // axios.get('/api/functionalareas/optionsByUser').then((response) => {
            //     // this.functional_areas = [{label: 'Todas', value: null}];
            //     _.each(response.data, (description, id) => {
            //         this.functional_areas.push({label: description, value: id})
            //     });
            // });
            // axios.get('/api/devices/options').then((response) => {
            //     _.each(response.data, (name, id) => {
            //         this.devices[id] = name;
            //     });
            // });
            this.fetchFunctionalAreasForUser();
            let query = this.$route.query;
            _.each(query, (value, key) => {
                if (query[key] != null && this.filters[key] != undefined){
                    this.filters[key] = query[key];
                }
            });
        },
    	methods: {
            ...mapActions(["fetchFunctionalAreasForUser"]),
            weekPickerChange(value) {
                this.filters.date_from = value[0];
                this.filters.date_to = value[1];
            },
            getStatus() {
                axios.get('/api/functionalareas/'+this.filters.functional_area_id+'/statusbydate', {
                    params: {
                        aspect: 'OA',
                        date_from: this.filters.date_from,
                        date_to: this.filters.date_to
                    }
                }).then((response) => {
                    let closed = true;
                    let partiallyClosed = false;
                    let closedPeriods = [];
                    // console.log(response.data);
                    this.status = response.data;
                    this.week_days.forEach(day => {
                        let st = response.data.find(elem => elem.date_from <= day.date && elem.date_to >= day.date);
                        if (st != undefined && st.status == 'CLO') {
                            partiallyClosed = true;
                            day.statusClosed = true;
                        } else {
                            closed = false;
                            day.statusClosed = false;
                        }
                    });
                    response.data.forEach(elem => {
                        if (elem.status == 'CLO') {
                            closedPeriods.push(`${elem.date_from} a ${elem.date_to}`);
                        }
                    });
                    this.closedPeriods = closedPeriods.join(', ');
                    this.statusClosed = closed;
                    this.statusPartiallyClosed = partiallyClosed;
                    this.statusFetched = true;
                    // console.log(response.data);
                    // this.statusClosed = false;
                    // for (let i in response.data) {
                    //     if (response.data[i].status == 'CLO') {
                    //         this.statusClosed = true;
                    //     }
                    // }
                });
            },
            handlefiltersSubmited(values) {
                moment.locale('es');
                let date_from = moment(values.date_from);
                const days = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
                this.week_days = [];
                for (let i = 0; i < 7; i++) {
                    this.week_days.push({
                        date: date_from.format('YYYY-MM-DD'),
                        label: days[date_from.format('d')],
                        statusClosed: false
                    });
                    date_from.add(1, 'days');
                }
            },
            handleFillForm(row, date) {
                if (this.statusClosed) return;
                this.approveForm.computed = row.records[date].computed || {};
                this.approveForm.employee_id = row.employee_id;
                this.approveForm.date = date;
                this.approveForm.employee_name = row.employee_name;
                let unauthorized = (row.records[date].unauthorized_overtime != undefined) ? parseFloat(row.records[date].unauthorized_overtime) : 0;
                let computedOt = (row.records[date].computed && row.records[date].computed.overtime != undefined) ? parseFloat(row.records[date].computed.overtime) : 0;
                let overtimeToAuthorize = unauthorized + computedOt;
                let totalMinutes = Math.round(overtimeToAuthorize * 60);
                // Tope máximo aprobable = horas extra realmente trabajadas
                this.approveForm.maxOvertimeMinutes = totalMinutes;
                this.approveForm.overtimeToAuthorizeHours = Math.floor(totalMinutes / 60);
                this.approveForm.overtimeToAuthorizeMins = totalMinutes % 60;
                this.approveForm.comment = (row.records[date].comment != undefined) ? row.records[date].comment : null;
                this.approveVisible = true;
            },
            handleFillMassForm() {
                let data = this.$refs['dataTable'].data.map((item) => {
                    return {
                        label: item.employee_name,
                        key: item.employee_id,
                        id_number: item.employee_company_id_number
                    };
                });
                this.massApproveForm.employees = data;
                this.massApproveForm.selectedEmployees = [];
                let days = {};
                this.week_days.forEach((day) => {
                    days[day.date] = false;
                });
                this.massApproveForm.selectedDays = days;
                this.massApproveForm.overtimeToAuthorizeHours = 0;
                this.massApproveForm.overtimeToAuthorizeMins = 0;
                // this.approveForm.comment = (row.records[date].comment != undefined) ? row.records[date].comment : null;
                this.massApproveForm.comment = null;
                this.massApproveVisible = true;
            },
    		handleApprove() {
                if (this.statusClosed) return;
                if (this.$auth.can(['overtime.approve']) && this.approveExceedsLimit) {
                    this.$alert('No puede aprobar más de ' + this.formatTime(this.approveForm.maxOvertimeMinutes / 60) + ' de horas extra, que es lo realmente trabajado por el empleado.', 'Límite excedido', {
                        confirmButtonText: 'Entendido',
                        type: 'warning'
                    });
                    return;
                }
    			this.approveVisible = false;
                let data = {
                    date: this.approveForm.date,
                }
                if (this.$auth.can(['overtime.comment'])) {
                    data.comment = this.approveForm.comment;
                }
                if (this.$auth.can(['overtime.approve'])) {
                    data.authorized_minutes = this.approveForm.overtimeToAuthorizeHours * 60 + this.approveForm.overtimeToAuthorizeMins;
                }
                axios.post('/api/employees/'+this.approveForm.employee_id+'/authorizedovertime', data)
                    .then((response) => {
                        let msg = (response.data && response.data.message) ? response.data.message : 'Horas extra autorizadas correctamente.';
                        this.$alert(msg, 'Autorización Exitosa', {
                            confirmButtonText: 'Aceptar',
                            type: 'success'
                        });
                        this.$refs['dataTable'].fetchItems();
                    })
                    .catch((error) => {
                        let errorMsg = 'No se pudo autorizar las horas extra.';
                        if (error.response && error.response.data && error.response.data.message) {
                            errorMsg = error.response.data.message;
                        } else if (error.response && error.response.status === 403) {
                            errorMsg = 'No posee permisos suficientes para aprobar horas extra o el período está cerrado.';
                        }
                        this.$alert(errorMsg, 'Error en Autorización', {
                            confirmButtonText: 'Entendido',
                            type: 'error'
                        });
                    });
                this.approveForm.employee_id = null;
                this.approveForm.date = null;
                this.approveForm.overtimeToAuthorizeHours = null;
                this.approveForm.overtimeToAuthorizeMins = null;
            },
            handleMassApprove() {
                if (this.statusClosed) return;
                let data = {
                    employee_ids: this.massApproveForm.selectedEmployees,
                    dates: [],
                }
                Object.entries(this.massApproveForm.selectedDays).forEach((entry) => {
                    if (entry[1]) {
                        data.dates.push(entry[0]);
                    }
                });
                if (this.$auth.can(['overtime.comment'])) {
                    data.comment = this.massApproveForm.comment;
                }
                if (this.$auth.can(['overtime.approve'])) {
                    data.authorized_minutes = this.massApproveForm.overtimeToAuthorizeHours * 60 + this.massApproveForm.overtimeToAuthorizeMins;
                }
    			this.massApproveVisible = false;
                axios.post('/api/employees/authorizedovertime', data)
                    .then((response) => {
                        let msg = (response.data && response.data.message) ? response.data.message : 'Aprobación masiva realizada correctamente.';
                        this.$alert(msg, 'Autorización Masiva', {
                            confirmButtonText: 'Aceptar',
                            type: 'success'
                        });
                        this.$refs['dataTable'].fetchItems();
                    })
                    .catch((error) => {
                        let errorMsg = 'No se pudo realizar la aprobación masiva.';
                        if (error.response && error.response.data && error.response.data.message) {
                            errorMsg = error.response.data.message;
                        }
                        this.$alert(errorMsg, 'Error en Autorización Masiva', {
                            confirmButtonText: 'Entendido',
                            type: 'error'
                        });
                    });
                this.approveForm.employee_id = null;
                this.approveForm.date = null;
                this.approveForm.overtimeToAuthorizeHours = null;
                this.approveForm.overtimeToAuthorizeMins = null;
            },
            employeesFilter(query, item) {
                // console.log(query);
                // console.log(item);
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 || query.indexOf(item.id_number) > -1;
            },
            handleClosePeriod() {
                let data = {
                    aspect: 'OA',
                    date_from: this.filters.date_from,
                    date_to: this.filters.date_to,
                    status: 'CLO'
                };
                axios.post('/api/functionalareas/'+this.filters.functional_area_id+'/statusbydate', data).then((response) => {
                    // console.log('handleClosePeriod response');
                    this.$refs['dataTable'].fetchItems();
                });
            },
            handleOpenPeriod() {
                let data = {
                    aspect: 'OA',
                    date_from: this.filters.date_from,
                    date_to: this.filters.date_to,
                    status: 'OPE'
                };
                axios.post('/api/functionalareas/'+this.filters.functional_area_id+'/statusbydate', data).then((response) => {
                    // console.log('handleOpenPeriod response');
                    this.$refs['dataTable'].fetchItems();
                });
            },
            formatTime(hours) {
                if (isNaN(hours)) {
                    return null;
                }
                return Math.floor(hours) + 'h ' + Math.round((hours - Math.floor(hours)) * 60) + 'm';
            },
            formatDateTime(datetime) {
                return moment(datetime).utcOffset(-5).format('YYYY-MM-DD HH:mm');
            },
            needAuthorization(row, date) {
                if (!row.records || !row.records[date]) return false;
                let rec = row.records[date];
                let totalOvertime = (rec.total_overtime != undefined) ? parseFloat(rec.total_overtime) : 0;
                let computedOvertime = (rec.computed && rec.computed.overtime != undefined) ? parseFloat(rec.computed.overtime) : 0;
                let isAuthorized = rec.authorized_by != null;
                return row.allow_overtime == 'AUTHORIZED' && (totalOvertime > 0 || computedOvertime > 0 || isAuthorized);
            }
    	}
   	}
</script>


